
import Cookie from 'js-cookie'

$(document).ready(function() {
    $('.rate-review').on('click', function(e) {
        e.preventDefault();

        var clickedEl = $(this);
        var id = clickedEl.data('review-id');

        if (!Cookie.get('helpfull_review_'+id)) {
            Cookie.set('helpfull_review_'+id, true);

            $.post('/api/review/' + id + '/increment', {}, function(data) {
                clickedEl.find('.count').html(data.count);
            });
        }
    });
});
